var _mask, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_8_5013",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C1.34315 0 0 1.34315 0 3V7.26667C0 8.92352 1.34315 10.2667 3 10.2667H8.24992L11.2499 14L11.2499 10.2667H12C13.6569 10.2667 15 8.92352 15 7.26667V5.13334V3C15 1.34315 13.6569 0 12 0H3Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24992 10.2667L9.02943 9.64028L8.72921 9.26667H8.24992V10.2667ZM11.2499 14L10.4704 14.6264L12.2499 16.8409L12.2499 14L11.2499 14ZM11.2499 10.2667V9.26667H10.2499L10.2499 10.2667L11.2499 10.2667ZM1 3C1 1.89543 1.89543 1 3 1V-1C0.79086 -1 -1 0.790864 -1 3H1ZM1 7.26667V3H-1V7.26667H1ZM3 9.26667C1.89543 9.26667 1 8.37124 1 7.26667H-1C-1 9.47581 0.790861 11.2667 3 11.2667V9.26667ZM8.24992 9.26667H3V11.2667H8.24992V9.26667ZM7.47041 10.8931L10.4704 14.6264L12.0294 13.3736L9.02943 9.64028L7.47041 10.8931ZM12.2499 14L12.2499 10.2667L10.2499 10.2667L10.2499 14L12.2499 14ZM12 9.26667H11.2499V11.2667H12V9.26667ZM14 7.26667C14 8.37124 13.1046 9.26667 12 9.26667V11.2667C14.2091 11.2667 16 9.47581 16 7.26667H14ZM14 5.13334V7.26667H16V5.13334H14ZM14 3V5.13334H16V3H14ZM12 1C13.1046 1 14 1.89543 14 3H16C16 0.790862 14.2091 -1 12 -1V1ZM3 1H12V-1H3V1Z",
    fill: "#949494",
    mask: "url(#path-1-inside-1_8_5013)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/Comment.880499741116d0a2c2dff2664a2893ff.svg";
export { ForwardRef as ReactComponent };